import React from 'react'

const LocaleHandler = React.createContext({ locale: "", setLocale: (data: any) => {} })

export default LocaleHandler;